import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { AllocationConsole } from "../features/allocation/AllocationConsole";

interface AllocationSearch {
  node?: string;
}

export const Route = createFileRoute("/allocation")({
  validateSearch: (search: Record<string, unknown>): AllocationSearch => ({
    node: typeof search.node === "string" ? search.node : undefined,
  }),
  component: AllocationRoute,
});

function AllocationRoute() {
  const { node } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <AllocationConsole
      node={node ?? null}
      onNodeChange={(key) =>
        void navigate({ search: { node: key ?? undefined }, replace: true })
      }
    />
  );
}
